import { useState } from "react";
import { toast } from "sonner";
import api from "../../../lib/api";
import { btnGhost, btnPrimary, fmtDateTimeWIB, fmtIDR, inp } from "../util";

const num = (s) => Number(String(s).replace(/\D/g, "")) || 0;
const LBL = { customer_name: "Customer", country: "Negara PO", total_idr: "Total PO", notes: "Catatan", "payment.amount_idr": "Nominal payment", "payment.reporting_date": "Tgl payment", "payment.notes": "Catatan payment" };
const show = (f, x) => (typeof x === "number" ? fmtIDR(x) : x || "—");

function FixForm({ c, countries, done }) {
    const [pid, setPid] = useState("");
    const p = (c.payments || []).find((x) => x.id === pid);
    const [f, setF] = useState({ customer_name: c.customer_name, country: c.country, total_idr: String(c.total_idr), notes: c.notes || "", amount_idr: "", payment_date: "", pnotes: "", reason: "" });
    const s = (k) => (e) => setF({ ...f, [k]: e.target.value });
    const pick = (e) => {
        const x = (c.payments || []).find((y) => y.id === e.target.value);
        setPid(e.target.value);
        setF({ ...f, amount_idr: x ? String(x.amount_idr) : "", payment_date: x?.reporting_date || "", pnotes: x?.notes || "" });
    };
    const save = async () => {
        if (!f.reason.trim()) return toast.error("Alasan koreksi wajib diisi");
        if (p ? !num(f.amount_idr) : !num(f.total_idr)) return toast.error("Nominal harus lebih dari 0");
        try {
            if (p) await api.put(`/reporting/v2/recon/cases/${c.id}/payments/${p.id}`, { amount_idr: num(f.amount_idr), payment_date: f.payment_date, notes: f.pnotes, reason: f.reason });
            else await api.put(`/reporting/v2/recon/cases/${c.id}`, { customer_name: f.customer_name, country: f.country, total_idr: num(f.total_idr), notes: f.notes, reason: f.reason });
            toast.success("Koreksi disimpan");
            done();
        } catch (e) { const d = e?.response?.data?.detail; toast.error(Array.isArray(d) ? (d[0]?.loc?.includes("reason") ? "Alasan koreksi minimal 3 karakter" : d[0]?.msg || "Data tidak valid") : d?.toString() || "Gagal menyimpan"); }
    };
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 border border-amber-200 bg-amber-50/40 rounded-sm p-2 mt-1" data-testid={`po-fix-form-${c.case_id}`}>
            <select className={`${inp} sm:col-span-2`} value={pid} onChange={pick} data-testid="po-fix-target">
                <option value="">Koreksi data PO</option>
                {(c.payments || []).map((x) => <option key={x.id} value={x.id}>Payment {x.reporting_date} · {fmtIDR(x.amount_idr)}</option>)}
            </select>
            {!p && <>
                <input className={inp} value={f.customer_name} onChange={s("customer_name")} placeholder="Nama customer" data-testid="po-fix-customer" />
                <select className={inp} value={f.country} onChange={s("country")} data-testid="po-fix-country">{countries.map((x) => <option key={x}>{x}</option>)}</select>
                <input className={inp} inputMode="numeric" value={f.total_idr} onChange={s("total_idr")} placeholder="Total PO (Rp)" data-testid="po-fix-total" />
                <input className={inp} value={f.notes} onChange={s("notes")} placeholder="Catatan" data-testid="po-fix-notes" />
            </>}
            {p && <>
                <input className={inp} inputMode="numeric" value={f.amount_idr} onChange={s("amount_idr")} placeholder="Nominal payment (Rp)" data-testid="po-fix-amount" />
                <input type="date" className={inp} value={f.payment_date} onChange={s("payment_date")} data-testid="po-fix-date" />
                <input className={`${inp} sm:col-span-2`} value={f.pnotes} onChange={s("pnotes")} placeholder="Catatan payment" data-testid="po-fix-pnotes" />
            </>}
            <input className={`${inp} sm:col-span-2`} value={f.reason} onChange={s("reason")} placeholder="Alasan Koreksi (wajib)" data-testid="po-fix-reason" />
            <button type="button" className={`${btnPrimary} sm:col-span-2`} onClick={save} data-testid="po-fix-save">Simpan koreksi</button>
        </div>
    );
}

function History({ c }) {
    const revs = [...(c.revisions || [])].reverse();
    if (!revs.length) return null;
    return (
        <div className="mt-1 text-[11px] text-neutral-500" data-testid={`po-history-${c.case_id}`}>
            <b className="text-neutral-600">Riwayat koreksi</b>
            {revs.map((r) => (
                <div key={r.id} className="border-l-2 border-mist pl-2 mt-1" data-testid={`po-rev-${r.id}`}>
                    <div>{fmtDateTimeWIB(r.at)} · {r.by} · <i>{r.reason}</i></div>
                    {r.changes.map((x) => <div key={x.field}>{LBL[x.field] || x.field}: {show(x.field, x.old)} → {show(x.field, x.new)}</div>)}
                </div>
            ))}
        </div>
    );
}

export function PoCaseFix({ c, countries, manage, done }) {
    const [open, setOpen] = useState(false);
    return (
        <>
            {manage && <button type="button" className={`${btnGhost} !px-2 !py-1 mt-1`} onClick={() => setOpen(!open)} data-testid={`po-fix-btn-${c.case_id}`}>{open ? "Tutup koreksi" : "Koreksi / Edit"}</button>}
            {open && <FixForm c={c} countries={countries} done={() => { setOpen(false); done(); }} />}
            <History c={c} />
        </>
    );
}
